import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import StarRatings from "react-star-ratings";
import { fetchProducts } from "../../features/product/productThunks";
import noProductFound from "../../assets/lotties/no-products-found.json";
import loadingLottie from "../../assets/lotties/loading.json";
import "./productSection.css";
import Lottie from "lottie-react";

export default function ProductSection({ endPoint, title, link }) {
  const dispatch = useDispatch();
  const { items: products, loading } = useSelector((state) => state.product);

  useEffect(() => {
    dispatch(fetchProducts({ endPoint, page: 1 }));
  }, [dispatch, endPoint]);

  return (
    <div className="productSection-container">
      <h2 className="productSection-title">{title}</h2>

      <div className="productSection-list">
        {loading ? (
          <div className="productSection-loading">
            <Lottie
              animationData={loadingLottie}
              loop
              autoplay
              style={{ height: "150px", width: "150px" }}
            />
          </div>
        ) : products.length > 0 ? (
          products.slice(0, 4).map((product) => (
            <Link className="productSection-link" to={`/product-details/${product._id}`}>
              <div className="productSection-card" key={product._id}>
                <div className="productSection-image-container">
                  <img
                    className="productSection-image"
                    src={`https://shop-co-backend-stk3.onrender.com/upload/${product.mainImage}`}
                    alt={`${product.brand} ${product.name} – worldwide shipping online shopping`}
                  />
                </div>
                <div className="productSection-details">
                  <h3 className="productSection-name">{product.name}</h3>
                  <div className="productSection-rating">
                    <StarRatings
                      rating={product.averageRating}
                      starRatedColor="gold"
                      numberOfStars={5}
                      starDimension="20px"
                      starSpacing="1px"
                    />
                    <p className="productSection-averageRating">{product.averageRating}</p>
                  </div>
                  <div className="productSection-prices">
                    <h4 className="productSection-price">{`$${product.priceAfterDiscount}`}</h4>
                    <h4 className="productSection-price-discounted">{`$${product.price}`}</h4>
                    <h5 className="productSection-discount">{`${product.discount}%`}</h5>
                  </div>
                </div>
              </div>
            </Link>
          ))
        ) : (
          <div className="productSection-lottie-wrapper">
            <Lottie
              animationData={noProductFound}
              loop
              autoplay
              style={{ height: '200px', width: '200px' }}
            />
            <p className="productSection-no-products">
              No products found.
            </p>
          </div>
        )}
      </div>

      <div className="productSection-btn-container">
        <Link to={link} className="productSection-btn">
          View All
        </Link>
      </div>
    </div>
  );
}
